import { NgModule } from '@angular/core';
import { IonicPageModule } from 'ionic-angular';
import {HomogenizationOrderInlineAddPage} from './homogenization-order-inline-add';
import { TooltipsModule } from 'ionic-tooltips';
import { MomentModule } from 'angular2-moment/moment.module';

@NgModule({
    declarations: [
        HomogenizationOrderInlineAddPage,
    ],
    imports: [
        IonicPageModule.forChild(HomogenizationOrderInlineAddPage),
        TooltipsModule,
        MomentModule
    ],
})
export class HomogenizationOrderInlineAddPageModule { }


// WEBPACK FOOTER //
// ./src/pages/homogenization-order-inline-add/homogenization-order-inline-add.module.ts